/* eslint-disable react/prop-types */
import { Spin } from 'antd';
import { Formik } from 'formik';

const GenericForm = ({
  initialValues,
  validationSchema,
  onSubmit,
  submitButtonLabel,
  loadingStatus,
  loadingText = 'loading...',
  children,
  ...props
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      {...props}
    >
      {({ handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          <Spin tip={loadingText} spinning={loadingStatus}>
            {children}
          </Spin>
        </form>
      )}
    </Formik>
  );
};

export default GenericForm;
